export const commentConstant = {
  // Get comments by opportunity
  GET_COMMENTS_BY_OPPORTUNITY_R: "GET_COMMENTS_BY_OPPORTUNITY_R",
  GET_COMMENTS_BY_OPPORTUNITY_S: "GET_COMMENTS_BY_OPPORTUNITY_S",
  GET_COMMENTS_BY_OPPORTUNITY_F: "GET_COMMENTS_BY_OPPORTUNITY_F",

  // Get comment count
  GET_COMMENT_COUNT_R: "GET_COMMENT_COUNT_R",
  GET_COMMENT_COUNT_S: "GET_COMMENT_COUNT_S",
  GET_COMMENT_COUNT_F: "GET_COMMENT_COUNT_F",

  // Create comment
  CREATE_COMMENT_R: "CREATE_COMMENT_R",
  CREATE_COMMENT_S: "CREATE_COMMENT_S",
  CREATE_COMMENT_F: "CREATE_COMMENT_F",

  // Update comment
  UPDATE_COMMENT_R: "UPDATE_COMMENT_R",
  UPDATE_COMMENT_S: "UPDATE_COMMENT_S",
  UPDATE_COMMENT_F: "UPDATE_COMMENT_F",

  // Delete comment
  DELETE_COMMENT_R: "DELETE_COMMENT_R",
  DELETE_COMMENT_S: "DELETE_COMMENT_S",
  DELETE_COMMENT_F: "DELETE_COMMENT_F",

  // Clear comments state
  CLEAR_COMMENTS_STATE: "CLEAR_COMMENTS_STATE",
};
